import { HTMLMotionProps, m } from "framer-motion";
import { forwardRef } from "react";

import { cn } from "@/common/utils/ui";

/* -------------------------------------------------------------------------------------------------
 * Video
 * -----------------------------------------------------------------------------------------------*/

interface VideoProps extends Omit<HTMLMotionProps<"video">, "src"> {
  fileName: string;
  disableLinkFallback?: boolean;
}

const Video = forwardRef<HTMLVideoElement, VideoProps>(
  (
    {
      fileName,
      className,
      width = "426",
      height = "240",
      controls = false,
      preload = "auto",
      playsInline = true,
      autoPlay = true,
      loop = true,
      muted = true,
      disableLinkFallback,
      ...rest
    },
    ref,
  ) => (
    <m.video
      ref={ref}
      className={cn(
        "absolute top-0 left-0 h-full w-full object-cover",
        className,
      )}
      width={width}
      height={height}
      controls={controls}
      preload={preload}
      playsInline={playsInline}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      poster={`/videos/${fileName}.webp`}
      {...rest}
    >
      <source src={`/videos/${fileName}.webm`} type="video/webm" />
      <source src={`/videos/${fileName}.mp4`} type="video/mp4" />
      <p>
        Your browser doesn&apos;t support HTML video.
        {disableLinkFallback ? null : (
          <>
            Here is a
            <a href={`/videos/${fileName}.mp4`} download={`${fileName}.mp4`}>
              link to the video
            </a>{" "}
            instead.
          </>
        )}
      </p>
    </m.video>
  ),
);

Video.displayName = "Video";

/* -----------------------------------------------------------------------------------------------*/

export { Video };
export type { VideoProps };
